<button type="button" class="{{styleClass}}" (click)="openDaumApi()">우편번호 찾기</button>